import Box, { BoxProps } from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import { useTheme, alpha } from '@mui/material/styles';
import * as Device from 'react-device-detect';

export interface FormFooterProps extends BoxProps {
  children: React.ReactNode;
  hide?: boolean;
}

export const FormFooter = (props: FormFooterProps) => {
  const { hide = false, children, ...boxProps } = props;
  const theme = useTheme();

  if (Device.isMobile) {
    return (
      <Fade in={!hide} timeout={150}>
        <Box
          position="absolute"
          bottom={`calc(env(safe-area-inset-bottom) * -1)`} // adjust for safe area inset
          pb="calc(env(safe-area-inset-bottom) + 16px)"
          px={2}
          pt={2}
          width="100%"
          sx={{
            backgroundColor: alpha(theme.palette.background.paper, 0.5),
            backdropFilter: 'blur(5px)',
            borderTop: `1px solid ${alpha('#ffffff', 0.1)} `,
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10,
            ...boxProps.sx,
          }}
        >
          {children}
        </Box>
      </Fade>
    );
  }

  return (
    <Box
      p={2}
      width="100%"
      sx={{
        backgroundColor: alpha(theme.palette.background.paper, 0.5),
        borderTop: `1px solid ${alpha('#ffffff', 0.1)} `,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...boxProps.sx,
      }}
    >
      {children}
    </Box>
  );
};
